import { decimalCents, parseCents } from '../components/distributor-cash/cashMoney';

export const CATEGORY_FAMILIES = [
  { familyKey: 'membrane_wrap', label: 'Membrane Wrap' },
  { familyKey: 'membrane_wrap_lite', label: 'Membrane Wrap Lite' },
];
export const MAX_PIECE_PRICE_CENTS = 100000000;
export const validCategoryRates = (rates, { allowZero = false } = {}) =>
  Array.isArray(rates) &&
  rates.length <= CATEGORY_FAMILIES.length &&
  new Set(rates.map((rate) => rate?.familyKey)).size === rates.length &&
  rates.every(
    (rate) =>
      CATEGORY_FAMILIES.some((family) => family.familyKey === rate?.familyKey) &&
      Number.isSafeInteger(rate.pricePerPieceCents) &&
      rate.pricePerPieceCents >= (allowZero ? 0 : 1) &&
      rate.pricePerPieceCents <= MAX_PIECE_PRICE_CENTS
  );
export const validCategorySettings = (settings, { allowZero = true } = {}) =>
  settings &&
  (settings.pricingBasis === undefined || ['piece', 'unit'].includes(settings.pricingBasis)) &&
  (settings.categoryRates === undefined ||
    validCategoryRates(settings.categoryRates, { allowZero })) &&
  (settings.pricingBasis !== 'piece' || Array.isArray(settings.categoryRates));
export const categoryDraft = (rates = []) =>
  Object.fromEntries(
    CATEGORY_FAMILIES.map(({ familyKey }) => [
      familyKey,
      decimalCents(rates.find((rate) => rate.familyKey === familyKey)?.pricePerPieceCents),
    ])
  );
// Empty values omit a category; they never inherit a legacy product or unit price.
export function categoryRatesFromDraft(draft, { allowZero = false } = {}) {
  const rates = [];
  for (const { familyKey } of CATEGORY_FAMILIES) {
    const value = draft?.[familyKey];
    if (value === undefined || value === '') continue;
    const cents = parseCents(value);
    if (cents === null || cents < (allowZero ? 0 : 1) || cents > MAX_PIECE_PRICE_CENTS) return null;
    rates.push({ familyKey, pricePerPieceCents: cents });
  }
  return rates;
}
export const sameCategoryRates = (left, right) =>
  validCategoryRates(left, { allowZero: true }) &&
  validCategoryRates(right, { allowZero: true }) &&
  left.length === right.length &&
  left.every((rate) =>
    right.some(
      (other) =>
        other.familyKey === rate.familyKey && other.pricePerPieceCents === rate.pricePerPieceCents
    )
  );
